import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../localization/react'
import Sport from '../../typings/Sport'

interface Props {
  sports: Array<Sport>
}

const ValidSports: React.FC<React.PropsWithChildren<Props>> = ({ sports }) => {
  const sportsCommaSeparated = sports.map((sport) => sport.name).join(', ')

  return (
    <div>
      <Text size="small" color="subtleText">
        <Localized id="valid-sports" />
      </Text>
      <Text>{sports.length > 0 ? sportsCommaSeparated : <Localized id="all" />}</Text>
    </div>
  )
}

export default ValidSports
